export default __webpack_public_path__ + "static/media/988.dbf1d74c.jpg";